import React from 'react';
import clsx from 'clsx';

import CheckCircleIcon from '@smart-tv/components/icons/check-circle';
import Typography from '@smart-tv/components/typography';

import useTimeout from '@smart-tv/hooks/use-timeout';
import styles from './feedback-dialog.module.scss';

const AUTO_CLOSE_TIMEOUT = 1000;

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  message: string;
  onClose: () => void;
}

export const FeedbackDialogContent = (props: Props) => {
  const { onClose, message, className, ...rest } = props;

  useTimeout(() => onClose(), AUTO_CLOSE_TIMEOUT);

  return (
    <div className={clsx(styles['feedback-dialog'], className)} {...rest}>
      <CheckCircleIcon className={styles['feedback-dialog__icon']} size={136} color="success" />

      <Typography className={styles['feedback-dialog__message']} variant="h3" component="div">
        {message}
      </Typography>
    </div>
  );
};

export default FeedbackDialogContent;
